import React from "react";
import Slider from "react-slick";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import './carousel.css'

const image1 = 'https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/rxnt-mockup.webp';
const image2 = 'https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/frank-mockup.webp';
const image3 = 'https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/svhs-mockup.webp';
const image4 = 'https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/tds-mockup.webp';
const image5 = 'https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/tynax-mockup.webp';
const image6 = 'https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/anatomie-mockup.webp';
const image7 = 'https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/vacsewcenter-mockup.webp';
const image8 = 'https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/wbes-mockup.webp';
const image9 = 'https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/openn-mockup.webp';
const image10 = 'https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/willship-mockup.webp';
const prevIcon = 'https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/dark-left-nav.svg';
const nextIcon = 'https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/dark-right-nav.svg';

const CustomPrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <img
            src={prevIcon}
            alt="Previous"
            className={`custom-arrow custom-prev ${className}`}
            style={{ ...style }}
            onClick={onClick}
        />
    );
};

const CustomNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <img
            src={nextIcon}
            alt="Next"
            className={`custom-arrow custom-next ${className}`}
            style={{ ...style }}
            onClick={onClick}
        />
    );
};

const urlRouting = [
    { pathname: "resources/portfolio/detail/rxnt", pageName: "rxnt" },
    { pathname: "resources/portfolio/detail/frank", pageName: "frank" },
    { pathname: "resources/portfolio/detail/svhs", pageName: "svhs" },
    { pathname: "resources/portfolio/detail/tds", pageName: "tds" },
    { pathname: "resources/portfolio/detail/tynax", pageName: "tynax" },
    { pathname: "resources/portfolio/detail/anatomie", pageName: "anatomie" },
    { pathname: "resources/portfolio/detail/vacsewcenter", pageName: "vacsewcenter" },
    { pathname: "resources/portfolio/detail/wbes", pageName: "wbes" },
    { pathname: "resources/portfolio/detail/openn", pageName: "openn" },
    { pathname: "resources/portfolio/detail/willship", pageName: "willship" },
];


const PortfolioCarousel = () => {
    const portfolioCarousel = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
    };

    const carouselItems = [
        {
            id: 1,
            image: image1,
            title: "RXNT",
            link: "https://www.rxnt.com",
            linkTitle: "www.rxnt.com",
            description: "A leader in healthcare technology solutions, RXNT is recognized on the annual Inc. Magazine list of 5000 Fastest-Growing Private Companies 2019, the most prestigious ranking of the nation’s fastest-growing private companies.",
            pathname: urlRouting.find(item => item.pageName === "rxnt").pathname
        },
        {
            id: 2,
            image: image2,
            title: "FRANK",
            link: "https://frankfoodsafety.com",
            linkTitle: "www.frankfoodsafety.com",
            description: "A company that helps businesses ensure food safety compliance in a simple and straightforward way, now overseeing over 500,000 meals per year in Australia.",
            pathname: urlRouting.find(item => item.pageName === "frank").pathname
        },
        {
            id: 3,
            image: image3,
            title: "Silicon Valley High School",
            link: "https://svhs.co",
            linkTitle: "www.svhs.co",
            description: "Silicon Valley High School offers students enrolled in traditional high schools or homeschooling programs the opportunity to access innovative, relevant, and compelling online high school courses.",
            pathname: urlRouting.find(item => item.pageName === "svhs").pathname
        },
        {
            id: 4,
            image: image4,
            title: "Tax Data Systems",
            link: "https://vikingcoders.com",
            linkTitle: "www.vikingcoders.com",
            description: "A web-based tax API serving major eCommerce websites since 2009. Joined Thomson Reuters in 2014, and maintain the broadest and deepest coverage of indirect tax content in 14,500 tax jurisdictions for more than 175 countries.",
            pathname: urlRouting.find(item => item.pageName === "tds").pathname
        },
        {
            id: 5,
            image: image5,
            title: "TYNAX",
            link: "https://tynax.com/",
            linkTitle: "www.tynax.com",
            description: "At the forefront of global high-tech patent trading, Tynax operates a cutting-edge exchange boasting hundreds of thousands of patents.",
            pathname: urlRouting.find(item => item.pageName === "tynax").pathname
        },
        {
            id: 6,
            image: image6,
            title: "ANATOMIE STYLE",
            link: "https://anatomie.com",
            linkTitle: "www.anatomie.com",
            description: "Founded by the visionary duo Kate and Shawn Boyer, Anatomie stands as a beacon of innovation in the realm of designer fashion.",
            pathname: urlRouting.find(item => item.pageName === "anatomie").pathname
        },
        {
            id: 7,
            image: image7,
            title: "VACSEWCENTER",
            link: "https://vacsewcenter.com",
            linkTitle: "www.vacsewcenter.com",
            description: "Vacsewcenter takes great pride in its vast inventory, offering a diverse selection of machines, parts, and supplies, including elusive and hard-to-find items.",
            pathname: urlRouting.find(item => item.pageName === "vacsewcenter").pathname
        },
        {
            id: 8,
            image: image8,
            title: "WBES",
            link: "https://www.westbocaexecutivesuites.com/",
            linkTitle: "www.westbocaexecutivesuites.com",
            description: "As West Boca Raton’s local provider of premium office space, WBES is optimally suited toward fulfilling the needs of our clients. With the resources of one of Boca’s largest property owners we are able to hire the most professional staff, offer the most luxurious furnishings and operate in a facility of the highest caliber.",
            pathname: urlRouting.find(item => item.pageName === "wbes").pathname
        },
        {
            id: 9,
            image: image9,
            title: "Openn",
            link: "https://www.openn.com/en-au",
            linkTitle: "www.openn.com",
            description: "Openn Negotiation is a transparent sales method that helps buyers and sellers find the true market price for a property through an online bidding platform.",
            pathname: urlRouting.find(item => item.pageName === "openn").pathname
        },
        {
            id: 10,
            image: image10,
            title: "Willship International",
            link: "https://willship.com.au",
            linkTitle: "www.willship.com.au",
            description: "Willship is the amalgamation of two specialized freight forwarders—one focused on international automotive freight, the other on general freight. The result is a team with over 100 years of industry experience and expertise in all elements of international shipping.",
            pathname: urlRouting.find(item => item.pageName === "willship").pathname
        },
    ];

    const navigate = useNavigate()
    const handlePageLink = (path) => {
        navigate(path)
    }

    return (
        <section className="portfolio-carousel-section">
            <Container fluid className="px-0">
                <Slider {...portfolioCarousel} className="portfolio-carousel">
                    {carouselItems.map(item => (
                        <div key={item.id} className="portfolio-item pt-0">
                            <Row className="align-items-center h-100">
                                <Col xs="12" lg="6" className="text-primary text-start">
                                    <div className="details-block px-2 px-lg-0">
                                        <h3 className="ft-wt-600 text-uppercase top-text">Portfolio</h3>
                                        <h2 className="my-2 my-lg-4 portfolio-title">{item.title}</h2>

                                        <a href={item.link} className="text-decoration-none text-primary ft-wt-500 brand-urls d-none d-lg-inline-block" target="_blank" rel="noreferrer">
                                            <p>{item.linkTitle}</p>
                                        </a>
                                        <h4 className="my-2 my-lg-4 fw-normal d-none d-lg-block">{item.description}</h4>
                                        <Button variant="primary" className="mt-2 mt-lg-5 mx-0 mx-lg-2 d-none d-lg-inline-flex" onClick={() => handlePageLink(item.pathname)}>Know More</Button>
                                    </div>
                                </Col>
                                <Col xs="12" lg="6" className="pt-4 pt-lg-0">
                                    <img src={item.image} alt={item.title} loading="lazy" className="img-fluid w-100 p-4 p-lg-0" />
                                    <div className="text-primary mx-4 d-block d-lg-none">
                                        <a href={item.link} className="text-decoration-none text-primary ft-wt-500 brand-urls" target="_blank" rel="noreferrer">
                                            <p>{item.linkTitle}</p>
                                        </a>
                                        <p className="my-4 fw-normal line-height-24">{item.description}</p>
                                        <Button variant="primary" className="mt-2 mt-lg-5 mx-0 mx-lg-2" onClick={() => handlePageLink(item.pathname)}>Know More</Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    ))}
                </Slider>
            </Container>
        </section>
    );
};

export default PortfolioCarousel;
